module.exports = __webpack_public_path__ + "img/smallLogo.21017d68.png";